var exports = {
  "D": "x0a7806d5--69ec5f--carousel",
};

module.exports = exports;
